// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1HL65","footer":"Form_footer__3AAjC"};